import React, { useState } from 'react';
import { submitContactForm } from '../../services/api';
import './ContactUs.scss';
import Breadcrumb from '../../components/Breadcrumb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faLocationDot } from '@fortawesome/free-solid-svg-icons';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  document.title = 'Contact Us';

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await submitContactForm(formData);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        company: '',
        subject: '',
        message: '',
      });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const breadcrumbItems = [
    { path: '/', label: 'Home' },
    { path: '/contact', label: 'Contact Us' },
  ];

  return (
    <div className="contact-us-page">
      <Breadcrumb items={breadcrumbItems} />
      <section className="page-header">
        <div className="container">
          <h1 className="page-header__title">Contact Us</h1>
        </div>
      </section>

      <section className="contact-form-section section section--light">
        <div className="container">
          <div className="section__header">
            <h2 className="section__title">Get in Touch</h2>
            <p className="section__description">
              Have questions about our services or need a consultation? Fill out the form below and
              our team will get back to you as soon as possible.
            </p>
          </div>

          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name" className="form-label">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Your Name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Your Email"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="company" className="form-label">
                  Company
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Your Company"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject" className="form-label">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Subject"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="form-control"
                  rows="5"
                  placeholder="Your Message"
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn--primary" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>

              {submitStatus === 'success' && (
                <div className="submit-status success">
                  Thank you for your message! We'll get back to you soon.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="submit-status error">
                  Sorry, there was an error sending your message. Please try again later.
                </div>
              )}
            </form>

            <div className="contact-info">
              <div className="contact-info__item">
                <FontAwesomeIcon icon={faEnvelope} />
                <div className="contact-info__content">
                  <h3 className="contact-info__title">Email</h3>
                  <p className="contact-info__text">info@devsecopsinc.io</p>
                </div>
              </div>

              <div className="contact-info__item">
                <FontAwesomeIcon icon={faPhone} />
                <div className="contact-info__content">
                  <h3 className="contact-info__title">Phone</h3>
                  <p className="contact-info__text">(305) 215-8383</p>
                </div>
              </div>

              <div className="contact-info__item">
                <FontAwesomeIcon icon={faLocationDot} />
                <div className="contact-info__content">
                  <h3 className="contact-info__title">Address</h3>
                  <p className="contact-info__text">
                    Doylestown, PA
                    <br />
                    United States
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
